export const defaults = {
  copyright:
    '© 2024 BODi. All rights reserved. All third party trademarks are the property of their respective owners.',
  links: [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'Contact Us/FAQ',
      href: 'https://faq.beachbody.com/app/home/lob/beach',
    },
    {
      label: 'Terms and Conditions',
      href: 'https://www.teambeachbody.com/shop/us/wcs/termsOfUse?locale=en_US',
    },
    {
      label: 'Privacy Policy',
      href: 'https://www.teambeachbody.com/shop/us/wcs/privacy?locale=en_US',
    },
    {
      label: 'CA Supply Chain',
      href: 'https://www.teambeachbody.com/shop/us/corporate/casupplychain?locale=en_US',
    },
  ],
  badges: [
    {
      url: '/images/small-footer/badge-bbb.svg',
      altText: 'Accredited Business',
    },
    {
      url: '/images/small-footer/badge-dsa.svg',
      altText: 'Accredited Business',
    },
    {
      url: '/images/small-footer/badge-digicert.png',
      altText: 'Accredited Business',
    },
  ],
}
